module.exports = __webpack_public_path__ + "static/stitcher-806c8c0c4b5c225ef93451f2f2c937a1.png";